import { Loader } from "react-feather";
import { styled, keyframes } from "styled-components";
import { Colors } from "../constants";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  color: ${Colors.Tan};
  animation: ${rotate} 2s linear infinite;
`;

const Loading = () => {
  return (
    <Wrapper>
      <Loader size={48} />
    </Wrapper>
  );
};

export default Loading;
